import { Avatar, Box, Divider, Text } from '@factorialco/deprecated-design-system'
import { Maybe, ProjectWorkersPanelDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Sidepanel from 'modules/core/components/Sidepanel'
import { useQuery } from 'modules/core/hooks/useQuery'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import Loading from 'modules/layout/components/Page/Loading'
import CostHistoryRecords from 'modules/project_management/components/CostHistoryRecords'

import { InsightCard } from '../InsightCard'

export interface IProjectWorkersSidepanelData {
  projectWorkerId: number
  employeeAccessAvatar: Maybe<string> | undefined
  employeeFullName: Maybe<string> | undefined
  imputedMinutes: Maybe<number> | undefined
  laborCostCents: Maybe<number> | undefined
  laborCostCurrency: string
  onClose: () => void
  showProjectWorkersPanel: boolean
}

const ProjectWorkersSidepanel = ({
  projectWorkerId,
  employeeAccessAvatar,
  employeeFullName,
  imputedMinutes,
  laborCostCents,
  laborCostCurrency,
  onClose,
  showProjectWorkersPanel,
}: IProjectWorkersSidepanelData) => {
  const { data, loading: loadingCostHistoryRecords } = useQuery(ProjectWorkersPanelDocument, {
    variables: {
      projectWorkerId,
    },
  })

  const costHistoryRecords = data?.projectManagement.projectWorkerCostHistoryRecords || []

  return (
    <Sidepanel
      title={i18n.t('project_management.project_workers.details.cost_history')}
      open={showProjectWorkersPanel}
      onClose={onClose}
      width={'wide'}
    >
      <Box flexDirection="row" alignItems="center" gap="s16" width="full">
        {employeeFullName && (
          <Avatar size="s40" url={buildUrl(employeeAccessAvatar)} label={employeeFullName} />
        )}
        <Text weight="medium" size="500" color="grey1000">
          {employeeFullName}
        </Text>
      </Box>
      <Box flexDirection="row" paddingTop="s16" paddingBottom="s32" gap="s32">
        <Box width="full">
          <InsightCard.Hours
            icon="clock"
            imputedMinutes={imputedMinutes || 0}
            title={i18n.t('project_management.project_workers.details.registered_hours')}
            titleGap="s2"
          />
        </Box>
        <Divider vertical />
        <Box width="full">
          <InsightCard.Cost
            icon="dollar-bill"
            totalCost={laborCostCents || 0}
            currency={laborCostCurrency}
            title={i18n.t('project_management.project_workers.details.labor_cost')}
            titleGap="s2"
          />
        </Box>
      </Box>
      {loadingCostHistoryRecords ? (
        <Loading />
      ) : (
        <Box flexDirection="row" width="full" paddingTop="s16">
          <CostHistoryRecords
            costHistoryRecords={costHistoryRecords}
            laborCostCurrency={laborCostCurrency}
          />
        </Box>
      )}
    </Sidepanel>
  )
}

export default observer(ProjectWorkersSidepanel)
